import { Route, BrowserRouter as Router, Routes } from 'react-router';
import AppLayout from './layout/AppLayout';
import AuthLayout from './layout/AuthLayout';
import SignIn from './pages/AuthPages/SignIn';
import SignUp from './pages/AuthPages/SignUp';
import Blank from './pages/Blank';
import Calendar from './pages/Calendar';
import Ecommerce from './pages/Dashboard/ECommerce';
import FormElements from './pages/Forms/FormElements';
import NotFound from './pages/OtherPage/NotFound';
import BasicTables from './pages/Tables/BasicTables';
import Alerts from './pages/UiElements/Alerts';
import Avatars from './pages/UiElements/Avatars';
import Badges from './pages/UiElements/Badges';
import Buttons from './pages/UiElements/Buttons';
import Images from './pages/UiElements/Images';
import Videos from './pages/UiElements/Videos';
import UserProfiles from './pages/UserProfiles';
import ProtectedRoute from './components/protectedRoutes/ProtectedRoute';
import PermissionProtectedRoute from './components/protectedRoutes/PermissionProtectedRoute';
import { Toaster } from 'react-hot-toast';
import UnProtectedRoute from './components/protectedRoutes/UnProtectedRoute';
import Colleges from './pages/Colleges/Colleges';
import Courses from './pages/Courses/Courses';
import LandingPage from './pages/LandingPage';
import Units from './pages/Units/Units';
import UnitDetailPage from './pages/Units/UnitDetail';
import HeroImages from './pages/HeroImages/HeroImages';
import HistoryPage from './pages/History/History';
import HistoryDetailPage from './pages/History/HistoryDetail';
import CouncilPage from './pages/Council/Council';
import CouncilPublicPage from './pages/Council/CouncilPublic';
import NewsPage from './pages/News/News';
import NewsDetailPage from './pages/News/NewsDetail';
import AboutPage from './pages/About/About';
import ChurchInfoPage from './pages/ChurchInfo/ChurchInfo';
import EventsPage from './pages/Events/Events';
import EventDetailPage from './pages/Events/EventDetail';
import FamiliesPage from './pages/Families/Families';
import FamilyDetailPage from './pages/Families/FamilyDetail';
import FamilyMembersPage from './pages/FamilyMembers/FamilyMembers';
import FamilyMemberDetailPage from './pages/FamilyMembers/FamilyMemberDetail';
import SubAdmins from './pages/SubAdmins/SubAdmins';
import SubAdminPermissions from './pages/SubAdmins/SubAdminPermissions';
import PaymentTypesPage from './pages/PaymentTypes/PaymentTypes';
import PaymentsPage from './pages/Payments/Payments';
import OutstandingPaymentsPage from './pages/OutstandingPayments/OutstandingPayments';

export default function App() {
  return (
    <>
      <Toaster />
      <Router>
        <Routes>
          {/* Landing Page */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/council/:id" element={<CouncilPublicPage />} />

          {/* Dashboard Layout */}
          <Route element={<AppLayout />}>
            <Route
              path="/unit"
              element={
                <ProtectedRoute>
                  <Units />
                </ProtectedRoute>
              }
            />
            <Route
              path="/unit/:id"
              element={
                <ProtectedRoute>
                  <UnitDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hero-images"
              element={
                <ProtectedRoute>
                  <HeroImages />
                </ProtectedRoute>
              }
            />
            <Route
              path="/history"
              element={
                <ProtectedRoute>
                  <HistoryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/history/:id"
              element={
                <ProtectedRoute>
                  <HistoryDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/council-admin"
              element={
                <ProtectedRoute>
                  <PermissionProtectedRoute resource="council" requiredAction="read">
                    <CouncilPage />
                  </PermissionProtectedRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/news"
              element={
                <ProtectedRoute>
                  <NewsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/news/:id"
              element={
                <ProtectedRoute>
                  <NewsDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/about-admin"
              element={
                <ProtectedRoute>
                  <AboutPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/church-info"
              element={
                <ProtectedRoute>
                  <PermissionProtectedRoute resource="church-info" requiredAction="read">
                    <ChurchInfoPage />
                  </PermissionProtectedRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/events"
              element={
                <ProtectedRoute>
                  <EventsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/events/:id"
              element={
                <ProtectedRoute>
                  <EventDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/families"
              element={
                <ProtectedRoute>
                  <PermissionProtectedRoute resource="families" requiredAction="read">
                    <FamiliesPage />
                  </PermissionProtectedRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/families/:id"
              element={
                <ProtectedRoute>
                  <FamilyDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/family-members"
              element={
                <ProtectedRoute>
                  <FamilyMembersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/family-members/:id"
              element={
                <ProtectedRoute>
                  <FamilyMemberDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sub-admins"
              element={
                <ProtectedRoute>
                  <SubAdmins />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sub-admins/:id"
              element={
                <ProtectedRoute>
                  <SubAdminPermissions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment-types"
              element={
                <ProtectedRoute>
                  <PermissionProtectedRoute resource="payment-types" requiredAction="read">
                    <PaymentTypesPage />
                  </PermissionProtectedRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/payments"
              element={
                <ProtectedRoute>
                  <PermissionProtectedRoute resource="payments" requiredAction="read">
                    <PaymentsPage />
                  </PermissionProtectedRoute>
                </ProtectedRoute>
              }
            />
            <Route
              path="/outstanding-payments"
              element={
                <ProtectedRoute>
                  <PermissionProtectedRoute resource="payment-obligations" requiredAction="read">
                    <OutstandingPaymentsPage />
                  </PermissionProtectedRoute>
                </ProtectedRoute>
              }
            />

            {/* <Route
              path="/courses"
              element={
                <ProtectedRoute>
                  <Courses />
                </ProtectedRoute>
              }
            /> */}

            {/* Others Page */}
            <Route path="/profile" element={<UserProfiles />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/blank" element={<Blank />} />

            {/* Forms */}
            <Route path="/form-elements" element={<FormElements />} />

            {/* Tables */}
            <Route path="/basic-tables" element={<BasicTables />} />

            {/* Ui Elements */}
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/avatars" element={<Avatars />} />
            <Route path="/badges" element={<Badges />} />
            <Route path="/buttons" element={<Buttons />} />
            <Route path="/images" element={<Images />} />
            <Route path="/videos" element={<Videos />} />
          </Route>

          {/* Auth Layout */}
          <Route element={<AuthLayout />}>
            <Route
              path="/signin"
              element={
                <UnProtectedRoute>
                  <SignIn />
                </UnProtectedRoute>
              }
            />
            <Route path="/signup" element={<SignUp />} />
          </Route>

          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}
